import { render, staticRenderFns } from "./iqc_inspection.vue?vue&type=template&id=c3bd2e1a&scoped=true&"
import script from "./iqc_inspection.vue?vue&type=script&lang=js&"
export * from "./iqc_inspection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3bd2e1a",
  null
  
)

export default component.exports